import { FC } from "react";

const Loader: FC = () => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className="h-10 w-10 animate-spin-fast text-lastbot-icon-muted"
      >
        <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20.5a9.5,9.5,0,1,1,9.5-9.5A9.5,9.5,0,0,1,12,21.5Z" className="opacity-15" />
        <path fill="currentColor" d="M12,1a11,11,0,0,1,11,11h-1.5a9.5,9.5,0,0,0-9.5-9.5Z" />
      </svg>
    </div>
  );
};

export default Loader;
